import { useCallback } from "react";
import { Controller, useFormContext } from "react-hook-form";

import { BasicPolicyQuestion } from "@covertree/new-business-graphql";
import { theme } from "@covertree/theme";
import { FormToggleCard } from "@covertree/ui";

interface Props {
  question: BasicPolicyQuestion;
}

export function ExtraQuestion({ question }: Props) {
  const { setValue, control, getValues, watch, trigger } = useFormContext();
  const noEmail = watch("noEmail");

  const handleToggle = useCallback(
    async (value: boolean, onChange: (val: boolean) => void) => {
      if (question.fieldName === "noEmail") {
        if (getValues("physicallyMailDocuments") !== undefined) {
          setValue("physicallyMailDocuments", !value);
        }

        if (!value) {
          setValue("emailAddress", "");
        }
      }
      onChange(!value);
      trigger("emailAddress");
    },
    [question]
  );

  return (
    <Controller
      control={control}
      name={question.fieldName}
      render={({ field: { value, onChange } }) => (
        <FormToggleCard
          title={question.label}
          checked={value}
          checkedCustomStyles={{
            backgroundColor: theme.palette.secondary.contrastText,
          }}
          onToggle={() => handleToggle(value, onChange)}
          tooltip={question.tooltip}
          disabled={
            question.fieldName === "physicallyMailDocuments" && !!noEmail
          }
        />
      )}
    />
  );
}
